/**
 * @file Formats an address object into a single display string.
 */

import type { Address } from "./types";

const SEPARATOR = ", ";
const BLANK = " ";

/**
 * Checks whether an address part has a real, non-blank value.
 */
const isFilled = (value?: string): boolean => {
  const hasValue = !!value;
  const isBlank = value === BLANK;

  return hasValue && !isBlank;
};

/**
 * Joins the filled address parts into one display string.
 */
const getAddress = (address: Address = {}): string => {
  const {
    postalCode,
    streetAddress,
    addressRegion,
    addressLocality,
  } = address;

  const parts = [
    streetAddress,
    addressLocality,
    addressRegion,
    postalCode,
  ];

  const values = parts.filter(isFilled);

  const result = values.join(SEPARATOR);

  return result;
};

export default getAddress;
